<template>
  <el-dialog title="选择导出" :visible="visible" :close-on-click-modal="false" width="800px" @close="handleCancel">
    <template slot="title">
      <div> 选择导出 </div>
    </template>
    <div>
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 25px 0"></div>
      <el-checkbox-group v-model="checkList" class="custom-checkbox-group" @change="handleCheckedChange">
        <el-checkbox
          v-for="item in colCheckList"
          :label="item.label"
          :value="item.vaule"
          :key="item.value"
          :disabled="item.disabled != undefined && item.disabled == true"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleExport()">确定导出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { exportFile } from '@/api/base'
import dayjs from 'dayjs'
export default {
  name: 'MulCheckExport',
  components: {},
  data() {
    return {
      visible: false,
      checkAll: false,
      isIndeterminate: false,
      checkList: [],
      colCheckList: [],
      source: '',
      type: 'all',
      param: {},
    }
  },
  methods: {
    init(param, colCheckList, source) {
      this.param = param
      this.source = source
      if (source == 'proxy') {
        this.handleExport()
      } else {
        this.colCheckList = colCheckList
        let content = this.$cookies.get('stall_export')
        if (content) {
          this.checkList = content.split(',')
        }
        if (this.checkList.length == 0) {
          for (const element of colCheckList) {
            if (element.isDefaultCheck != undefined && element.isDefaultCheck) {
              this.checkList.push(element.label)
            }
          }
        }
        this.handleCheckedChange(this.checkList)
        this.visible = true
      }
    },
    handleCheckAllChange() {
      this.checkList.length != this.colCheckList.length ? this.colCheckList : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.colCheckList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.colCheckList.length
    },
    async handleExport() {
      if (this.source != 'proxy') {
        this.param.cloumnList = []
        if (this.checkList.length == 0) {
          this.$message({ type: 'error', message: '请选择导出信息' })
          return
        }
        let exportCheckStr = this.checkList.join(',')
        for (const selectItem of this.colCheckList) {
          const checkItem = this.checkList.find(value => {
            return value == selectItem.label
          })
          if (checkItem != null) {
            this.param.cloumnList.push({
              CnName: selectItem.label,
              EnName: selectItem.value,
              ColLen: selectItem.CLen != undefined ? selectItem.CLen : 20,
              ColType: selectItem.type != undefined ? selectItem.type : 'string',
              IsMerge: selectItem.IsMerge != undefined ? selectItem.IsMerge : false,
              mergeKeys: selectItem.mergeKeys != undefined ? selectItem.mergeKeys : [],
            })
          }
        }
        this.$cookies.set('stall_export', exportCheckStr)
      }

      const { data } = await exportFile('/api/stallCashier/export', this.param)
      let date = ''
      let today = dayjs().format('YYYY-MM-DD')
      let start = this.param.startTime ? dayjs(this.param.startTime).format('YYYY-MM-DD') : ''
      let end = this.param.endTime ? dayjs(this.param.endTime).format('YYYY-MM-DD') : ''
      if (this.param.startTime && this.param.endTime) {
        date = start == end ? start : start + '至' + end
      } else if (this.param.startTime) {
        date = start + '至' + today
      } else if (this.param.endTime) {
        date = today + '至' + end
      }
      const fileName = this.source == 'proxy' ? (this.type == 'all' ? `${date}订单表` : `${date}订单快递表`) : `店铺收银导出${date}`

      const blob = new Blob([data.Blob], { type: 'application/vnd.ms-excel' })
      var a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = fileName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
      this.handleCancel()
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-checkbox-group .el-checkbox {
  /* 修改样式 */
  margin-right: 15px;
  margin-bottom: 15px;
  width: 18%;
}
.dialog-footer {
  position: relative;

  .checkbox-block {
    position: absolute;
    left: 28px;
    top: 8px;
  }

  .el-button {
    width: 100px !important;
    padding: 10px 10px !important;
  }
}
</style>
